// extracted by mini-css-extract-plugin
module.exports = {"cartShippingAddress":"cart-shipping-address_cartShippingAddress__3eK7S","header":"cart-shipping-address_header__8Ffzd","panel":"cart-shipping-address_panel__39p3Q"};